import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageHeading } from "../../../components/pageHeading";
import { UnderlineTabs } from "../../../components/tabs/underline";

const tabs = [
  { name: "Subscription", href: "/billing/subscription" },
  { name: "Bill history", href: "/billing/bill-history" },
];

// Billing shell: heading + underline tabs (same as the site details page).
// Each tab is still its own route: the active tab comes from the URL and
// picking one navigates. The tab's page renders into the <Outlet /> (see the
// /billing routes in RoutesWrapper).
const normalize = (path) => path.replace(/\/+$/, "");

function Billing() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = (
    tabs.find((tab) => normalize(location.pathname) === tab.href) || tabs[0]
  ).name;

  return (
    <div>
      <main className="py-6">
        <div className="px-4 sm:px-6 lg:px-6">
          <PageHeading title="Billing" />
          <div className="mb-6">
            <UnderlineTabs
              tabs={tabs}
              activeTab={activeTab}
              onChange={(name) =>
                navigate(tabs.find((tab) => tab.name === name).href)
              }
            />
          </div>
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export { Billing };
